export default {
  automaticBooking: {
    actions: {
      confirmAppointment: 'Afspraak bevestigen',
      createManualBooking: 'Handmatige afspraak maken',
    },
    description:
      'Kies een tijd die het beste voor u werkt. Als u geen geschikte tijd ziet, maak dan een handmatige afspraak.',
    header: 'Kies een andere tijd',
    screenTitle: 'Maak een afspraak',
  },
  bookWithReferral: {
    actions: {
      checkReferralCode: 'Verwijzingscode controleren',
    },
    caption:
      'De verwijzingscode kunt u vinden in de verwijsbrief. De code begint met “ZD” gevolgd door 9 cijfers.',
    dateOfBirth: {
      label: 'Geboortedatum',
      placeholder: 'dd/mm/yyyy',
    },
    errorMessage: {
      dateOfBirth: 'Geboortedatum is verplicht',
      internalServerError: 'Interne serverfout. Probeer het later opnieuw.',
      networkError:
        'Netwerkfout. Controleer uw verbinding en probeer het opnieuw.',
      notFound: 'Verwijzingscode niet gevonden',
      referralCode:
        "De verwijzingscode moet beginnen met 'ZD' gevolgd door 9 cijfers",
      underage:
        'Xpert Clinics accepteert geen patiënten jonger dan 18 jaar voor deze behandeling. Neem contact op met uw verwijzende arts als u vragen heeft.',
      unexpectedError:
        'Er is een onverwachte fout opgetreden. Probeer het later opnieuw.',
    },
    header: 'Afspraak maken met verwijzingscode',
    referralCode: {
      label: 'Verwijzingscode',
      placeholder: 'ZD123456789',
    },
  },
  confirmBooking: {
    actions: {
      changeAppointment: 'Afspraak wijzigen',
      confirmBooking: 'Afspraak bevestigen',
    },
    breadcrumbLink: 'Kies datum en tijd',
    header: 'Bevestig details',
    screenTitle: 'Maak een afspraak',
    selectDifferentTimeslot: 'Kies een ander tijdstip',
  },
  confirmDetails: {
    actions: {
      continue: 'Doorgaan',
      edit: 'Gegevens bewerken',
    },
    description:
      'Klopt de volgende persoonlijke informatie? Zo niet, pas dan alstublieft uw e-mailadres en telefoonnummer aan.',
    editDetails: {
      actions: {
        saveAndContinue: 'Opslaan en doorgaan',
      },
      email: {
        label: 'E-mailadres',
        placeholder: 'Voer uw e-mailadres in',
      },
      telephone: {
        label: 'Telefoonnummer',
        placeholder: 'Voer uw telefoonnummer in',
      },
    },
    header: 'Bevestig uw gegevens',
  },
  moreInformation: {
    actions: {
      continue: 'Doorgaan',
    },
    description:
      'Beantwoord alstublieft de volgende vragen, zodat we de juiste afspraak voor u kunnen boeken',
    header: 'We hebben meer informatie nodig',
    screenTitle: 'Maak een afspraak',
  },
  proposedAppointment: {
    actions: {
      confirmAppointment: 'Afspraak bevestigen',
      selectTimeSlot: 'Kies een andere tijd',
    },
    description:
      'Als de volgende voorgestelde afspraak niet geschikt is, kies dan een andere tijd.',
    error:
      'Er is een fout opgetreden bij het ophalen van de beschikbare tijden.',
    header: 'Voorgestelde afspraak',
    screenTitle: 'Maak een afspraak',
  },
  referralNotFound: {
    actions: {
      call: 'Bellen',
      cancel: 'Annuleren',
    },
    body: 'Als u denkt dat dit een vergissing is, bel ons dan op {{phone}}',
    title: 'Verwijzing niet gevonden',
  },
  referralSelection: {
    actions: {
      no: 'Nee',
      yes: 'Ja',
    },
    caption:
      'De verwijzingscode kunt u vinden in de verwijsbrief. De code begint met “ZD” gevolgd door 9 cijfers.',
    header: 'Heeft u een verwijzingscode?',
    noReferralModal: {
      actions: {
        call: 'Bellen',
        cancel: 'Annuleren',
      },
      body: `Om door te gaan, voer alstublieft uw verwijzingscode in. Als u er geen heeft of hulp nodig heeft, bel ons dan op {{phone}}`,
      title: 'U heeft een verwijzingscode nodig om een afspraak te maken',
    },
    screenTitle: 'Maak een afspraak',
  },
  selectClinic: {
    actions: {
      selectTimeSlot: 'Kies tijd',
    },
    breadcrumbLink: 'Terug',
    closestClinic: 'Kies de kliniek die het dichtst bij u in de buurt is',
    header: 'Kies kliniek',
    screenTitle: 'Maak een afspraak',
    selectDoctor: 'Kies een arts',
    showingDistance: 'Resultaten gesorteerd op afstand',
    subheader: 'Zoek klinieken',
    switchLabel:
      'Zoek de kliniek het dichtst bij u in de buurt. Dit kan later worden gewijzigd.',
    zipCodeInvalid: '*Ongeldige postcode',
    zipCodeLabel: 'Postcode',
  },
  selectDateTime: {
    actions: {
      reviewBooking: 'Boeking controleren',
    },
    breadcrumbLink: 'Selecteer locatie',
    dropdownDoctors: {
      all: 'Toon alles',
      label: 'Kies een arts',
    },
    header: 'Kies datum en tijd',
    noSlots: 'Geen beschikbare tijdsloten voor de geselecteerde locatie',
    screenTitle: 'Maak een afspraak',
    showAllSlots: 'Toon alle tijdsloten voor zorgverleners',
  },
}
